import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Swiper from 'swiper/bundle';

import '../scss/main.scss';

var $ = require("jquery");
require('bootstrap/dist/js/bootstrap.bundle');
require('blueimp-gallery/js/jquery.blueimp-gallery.min.js');
require('bootstrap-select/dist/js/bootstrap-select.min.js');

const sliderSection = document.querySelector("[class*='-slider']");
const figuresSection = document.querySelector("[class*='-slider']");
const accordion = document.querySelector('.accordion');
const efficiencyTable = document.querySelector('.efficiency');

// sticky navbar
var $navbox = $('#navigation-main'),
	oldScroll = $(window).scrollTop(),
	nav_delta = 0;

window.onscroll = function() {

	if (getWidth() >= 1200 ) {

		var scrollTop = $(window).scrollTop(),
			boxShadow = 'none';

		if (scrollTop > -1) {
			var scroll_delta = Math.abs(scrollTop - oldScroll),
				delta_sum = nav_delta + scroll_delta;

			if (oldScroll > scrollTop) { // UP
				if (scrollTop > 80) {
					nav_delta = delta_sum > 0 ? -80 : Math.min(-80,delta_sum);
					boxShadow = 'rgb(255, 255, 255) 0px -2px 0px 0px inset';
				}
				else {
					nav_delta = delta_sum > 0 ? 0 : delta_sum;
					boxShadow = 'none';
				}
			}
			else if (oldScroll == scrollTop) {
				nav_delta = -80;
				boxShadow = 'rgb(255, 255, 255) 0px -2px 0px 0px inset';
			}
			else { // DOWN
				nav_delta = (nav_delta - scroll_delta) < (0-($navbox.height() + 80)) ? (0-($navbox.height() + 80)) : (nav_delta - scroll_delta);
			}

			oldScroll = scrollTop;

			$navbox.css({
				'-webkit-transform': 'translate3d(0,'+nav_delta+'px,0)',
				'transform': 'translate3d(0,'+nav_delta+'px,0)',
				'box-shadow': boxShadow,
			});
		}
	}
	if ($(window).scrollTop() > getHeight()) {
		$('.footer-main .scroll_to').addClass('show');
	}
	else {
		$('.footer-main .scroll_to').removeClass('show');
	}
};
if ($(window).scrollTop() > 80) {
	oldScroll = $(window).scrollTop() - 80,
	$navbox.css({
		'-webkit-transform': 'translate3d(0,-80px,0)',
		'transform': 'translate3d(0,-80px,0)',
		'box-shadow': 'rgb(255, 255, 255) 0px -2px 0px 0px inset'
	}).addClass('visible');
}
else {
	$navbox.addClass('visible');
}

// scroll to element
$('body').on('click', '.scroll_to', function(e){

	var element = $(this)[0].hash || $(this).attr('href') || $(this).data('target');

	e.preventDefault();
	$('body, html').animate({
		scrollTop: $(element).offset().top
	}, {
		duration: 500
	});
});

// sidemenu
if ($('.ce--vd_areas > .vd_areas.service')[0]) {

	var $sidemenu = $('<div id="vd_areas-sidemenu" class="vd_areas-sidemenu container px-xl-0 list-group flex-xl-column flex-row"></div>');

	$('.ce--vd_areas > .vd_areas.service').each(function(){
		$('<a href="#'+ $(this).attr('id') +'" class="scroll_to list-group-item list-group-item-action">'+ $('.vd_area-header', this).text() +'</a>').appendTo($sidemenu);
	});

	$sidemenu.insertAfter('body > .header-main.navbar-expand-xl');

	$('body').scrollspy({
		target: '#vd_areas-sidemenu',
		offset: 100,
		// method: 'offset'
	});

}

if ($('.ce--vd_areas > .vd_services.show-side')[0]) {

	var $sidemenu = $('<div id="vd_areas-sidemenu" class="vd_areas-sidemenu container px-xl-0 list-group flex-xl-column flex-row"></div>');

	$('.ce--vd_areas > .vd_services.show-side .service').each(function(){
		var active = '';
		if ($(this).hasClass('muted')) {
			active = 'active';
		}
		$('<a href="'+ $(this).attr('href') +'" class="list-group-item list-group-item-action '+active+'">'+ $('.service-title', this).text() +'</a>').appendTo($sidemenu);
	});

	$sidemenu.insertAfter('body > .header-main.navbar-expand-xl');

}

// link select
$('.link-select').on('change', function(){
	$('<a href="'+ $(this).val() +'" class="d-none"></a>')[0].click();
});

// id select
// $('.filter-select').selectpicker();
$('.filter-select').on('change', function(){
	var id = $(this).val();

	if ($('.single-item').not('.sorting').filter(':visible')[0]) {

		$('.single-item').filter(':visible').eq(0).one('transitionend', function(){
			filterItems(id);

		});
		$('.single-item').addClass('sorting');
	}
	else {
		filterItems(id);
	}
});

// pagination
$('.pagination').on('click', 'a', function(e){

	e.preventDefault();

	var page = parseInt($(this).text()) || parseInt($(this).siblings('.current').text());

	if ($(this).hasClass('page-right')) {

		page = page + 1;

		$(this).siblings('.current').removeClass('current').next().not('.page-right').addClass('current');
		$(this).siblings('.page-left').removeClass('prehidden');
		if ($(this).prev().hasClass('current')) {
			$(this).addClass('prehidden');
		}
	}
	else if ($(this).hasClass('page-left')) {

		page = page - 1;

		$(this).siblings('.current').removeClass('current').prev().not('.page-left').addClass('current');
		$(this).siblings('.page-right').removeClass('prehidden');
		if ($(this).next().hasClass('current')) {
			$(this).addClass('prehidden');
		}
	}
	else {
		$(this).addClass('current').siblings().removeClass('current');
		if ($(this).prev().hasClass('page-left')) {
			$(this).siblings('.page-left').addClass('prehidden');
			$(this).siblings('.page-right').removeClass('prehidden');
		}
		else if ($(this).next().hasClass('page-right')) {
			$(this).siblings('.page-right').addClass('prehidden');
			$(this).siblings('.page-left').removeClass('prehidden');
		}
		else {
			$(this).siblings('.page-left').removeClass('prehidden');
			$(this).siblings('.page-right').removeClass('prehidden');
		}
	}

	var perPage = parseInt($(this).parent().prev().data('perPage'));

	$(this).parent().prev().find('.pagination-item').addClass('prehidden').slice((page-1)*perPage, page*perPage).removeClass('prehidden');
});

// events header
if ($('.event-single .header-main')[0]) {
	$('body > .header-main > .container').remove();
}

// landingpage
if ($('body').hasClass('landingpage') && $('.page-2cols')[0]) {
	$('body').addClass('landingpage-sub')
}
// landingpage slider
// if ($('#landingpage-slider')[0] && !$('body').hasClass('landingpage-sub')) {
if ($('#landingpage-slider')[0]) {
	var swiper = new Swiper('#landingpage-slider', {
		slidesPerView: '1.35',
		spaceBetween: 5,
		centeredSlides: true,
		loop: true,
		navigation: {
			nextEl: '#landingpage-slider .swiper-button-next',
			prevEl: '#landingpage-slider .swiper-button-prev',
		},
		scrollbar: {
			el: '#landingpage-slider .swiper-scrollbar',
			hide: false,
			draggable: true,
			snapOnRelease: true,
			dragSize: 140,
		},
		breakpoints: {
			992: {
				slidesPerView: '3',
				spaceBetween: 30,
			},
			768: {
				slidesPerView: '2',
				spaceBetween: 20,
			}
		}
	});
}

$('.vd_newsletter_form').submit(function(e) {
	e.preventDefault();
	var form = $(this);

    $.ajax({
        type: "POST",
        url: '/?type=776776',
		dataType: 'JSON',
        data: form.serialize(), // serializes the form's elements.
        success: function(data)
        {
          if (data.result) {
			$(form).find('.success').removeClass('d-none');
		  } else {
			$(form).find('.api-error').removeClass('d-none');
		  }
        }
    });
});

// layout
if ($('#c258')[0]) {
	$('#c258 header').addClass('container');
	$('#c258 header *').addClass('section-header-small');
}

// services hyphens
$('.vd_services .service:not(.small):not(.big)').each(function(){
	if (parseInt($('.service-title', this).width()) > parseInt($(this).width() - 70)) {
		$(this).addClass('hyphens');
	}
});

// aside empty
if ($('.page-2cols aside:not(.order-first) > .p-sticky').html() == '') {
	$('.page-2cols aside:not(.order-first)').remove();
}

// dealRoom
var dealRoomLoaded = false;
$('#dealroom-modal, #dealroom-modal-vd').on('show.bs.modal', function(){

	if (!dealRoomLoaded) initDealRoom($(this));
});

// newsletter
$('.newsletter-switch').on('click', function(){
	$('.vd_newsletter_form.position-fixed').toggleClass('active');
});

// yt video
$('.yt-video').on('click', function(e){

	e.preventDefault();

	if (!$(this).hasClass('active')) {
		$(this).addClass('active').append('<iframe class="embed-responsive-item" src="//www.youtube-nocookie.com/embed/'+$(this).data('video')+'?autoplay=1&loop=1&playlist='+$(this).data('video')+'&controls=2&rel=0&modestbranding=1&showinfo=0&enablejsapi=0&iv_load_policy=3&disablekb=1&cc_load_policy=0&playsinline=1" frameborder="0" allowfullscreen></iframe>');
	}
});

/* --- FUNCTIONS --- */
function filterItems(id) {

	$('.single-item').parent().removeClass('d-none').addClass('d-flex').end().each(function(){

		var $elm = $(this);

		if (String($elm.data('areas')).split(",").indexOf(id) > -1) {
			setTimeout(function(){
				$elm.removeClass('sorting');
			},50);
		}
		else {
			$elm.parent().addClass('d-none').removeClass('d-flex');
		}
	});

	$('.pagination-row').each(function(){
		if (id != "") {
			$(this).addClass('filter-active');
		}
		else {
			$(this).removeClass('filter-active');
		}
	});
}
function getWidth() {
	return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
}
function getHeight() {
	return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
}

// Debug trigger
// window['CookieService_external'] = true;
window['CookieBannerClosed'] = function CookieBannerClosed() {
    if (window['CookieService_external']) {
        if ($('.dealroom-wrapper').length > 0) {

            $('.dealroom-wrapper').find('.nocookie-message').fadeOut(350);
			$('.dealroom-wrapper').find('.tab-pane-link').removeClass('d-none');
			// Load modal
			// Load script from input
        }
		if ($('.newsfeed-wrapper').length > 0) {
            $('.newsfeed-wrapper').find('.nocookie-message').fadeOut(350);
			$.getScript('https://foerdernews-bb.de/fn.js');
        }
    }
}
// CookieBannerClosed();

function initDealRoom($modal) {

	$.getScript($('.dealroom-sdk-js', $modal).val(), function( data, textStatus, jqxhr ) {
		if (jqxhr.status == 200) {
			console.info('dealRoom SDK loaded');

			dealRoomLoaded = true;
		}
	});
}

// YT video HQ img missing fix
window['checkImgSize'] = function (img) {
	if (img.naturalWidth == 120) img.src = 'https://img.youtube.com/vi/'+$(img).parent().data('video')+'/0.jpg';
}